<template>
  <b-modal
    id="view_permission"
    title="Permissão"
    size="lg"
    hide-footer
    @show="resetModal()"
    @shown="
      get();
      $refs.autofocus.focus();
    "
    @hidden="resetModal()"
  >
    <b-overlay :show="loading" opacity="0.99">
      <form @submit="update">
        <WarningRequiredFields v-if="permissions.permission_admin.edit" />
        <ErrorsMessages :errors="errors" />
        <div class="row">
          <div class="col">
            <LabelRequiredField label="Grupo" />
            <select class="form-control" v-model="permission.group_id">
              <option value>SELECIONE...</option>
              <option v-for="group in groups" :key="group.id" :value="group.id">
                {{ String(group.name).toUpperCase() }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <LabelRequiredField label="Nome" />
            <input
              :disabled="!permissions.permission_admin.edit"
              type="text"
              ref="autofocus"
              class="form-control"
              v-model="permission.name"
            />
          </div>
          <div class="col">
            <LabelRequiredField label="Alvo" />
            <input
              :disabled="!permissions.permission_admin.edit"
              type="text"
              class="form-control"
              v-model="permission.target"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <LabelRequiredField label="Descrição" />
            <input
              type="text"
              class="form-control"
              v-model="permission.description"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <LabelRequiredField label="Ações" />
          </div>
          <div class="w-100"></div>
          <div class="col">
            <b-form-checkbox v-model="permission.actions.write" switch>
              Criar
            </b-form-checkbox>
          </div>
          <div class="col">
            <b-form-checkbox v-model="permission.actions.edit" switch>
              Modificar
            </b-form-checkbox>
          </div>
          <div class="col">
            <b-form-checkbox v-model="permission.actions.read" switch>
              Visualizar
            </b-form-checkbox>
          </div>
          <div class="col">
            <b-form-checkbox v-model="permission.actions.remove" switch>
              Remover
            </b-form-checkbox>
          </div>
        </div>
        <div class="form-group">
          <h6>
            <span class="text-muted">Criação:</span>
            {{ formatDate(permission.created_at) }}
          </h6>
          <h6>
            <span class="text-muted">Última alteração:</span>
            {{ formatDate(permission.updated_at) }}
          </h6>
        </div>
        <div class="form-group text-right">
          <v-btn class="v-primary" @click="$bvModal.hide('view_permission')">
            <span class="fa fa-arrow-left"></span> Voltar
          </v-btn>
          <v-btn
            v-if="permissions.permission_admin.edit"
            type="submit"
            class="v-success"
          >
            <span class="fa fa-check"></span> Salvar
          </v-btn>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import WarningRequiredFields from "../components/WarningRequiredFields";
import ErrorsMessages from "../components/ErrorsMessages";
import LabelRequiredField from "../components/LabelRequiredField";

import api from "../../services/api";
import { adminData } from "../../lib/functions";
import toast from "../../components/ToastNotification";

import { dialogConfirm } from "../../lib/functions";
import { formatDate } from "../../functions/format";

export default {
  name: "ViewPermission",
  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },
  props: {
    permission_id: [String, Number],
  },
  data() {
    return {
      permissions: {},
      errors: [],

      loading: false,

      groups: [],

      permission: {
        actions: { write: false, edit: false, read: false, remove: false },
      },
    };
  },
  created() {
    this.permissions = adminData().permissions;
  },
  methods: {
    formatDate,
    dialogConfirm,
    async resetModal() {
      this.permission = {
        actions: { write: false, edit: false, read: false, remove: false },
      };
    },
    async getGroups() {
      try {
        let response = await api.get("/admin/permission/groups");
        let { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.groups = groups;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async get() {
      try {
        this.loading = true;
        await this.getGroups();

        let params = { id: this.permission_id };
        let response = await api.get("/admin/permission", {
          params,
        });
        let { error, errors, permission } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.permission = permission;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(ev) {
      try {
        ev.preventDefault();
        this.loading = true;
        let {
          actions,
          description,
          group_id,
          id,
          name,
          target,
        } = this.permission;
        let params = { id, group_id, name, target, description, actions };
        let response = await api.patch("/admin/permission", params);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_permission");
          this.$emit("updated");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>